import React from 'react';
import clsx from 'clsx';
import styles from './Card.module.scss';

interface Props {
  className?: string;
  children: React.ReactNode;
}

export function Card({ className, children }: Props) {
  return <div className={clsx(styles.card, className)}>{children}</div>;
}
